import * as angular from 'angular';
import * as _ from 'lodash';
import './styling.scss';
import * as template from './template.html';
import { IAugmentedJQuery } from 'angular';
import { CurrentUserService } from 'services/currentUser';
import { getCallToActionMapping } from 'utilities/paymentsHelper';

const module = angular.module('call-to-action-card', []);

interface PaymentIssuesCardController extends angular.IStrictController {
    title: string;
    description: string;
    showPaymentButton: boolean;
    paymentsSref: string;
}

module.component('callToActionCard', {
    template: template,
    bindings: {
        policyInfos: '<'
    },
    controller: function(
        this: PaymentIssuesCardController,
        $stateParams: StateParams,
        $element: IAugmentedJQuery,
        currentUserService: CurrentUserService
    ) {
        this.$onInit = () => {
            const policyIndex = $stateParams.policyIndex;

            if (policyIndex) {
                currentUserService.getCustomerPolicyInfoByIndex(policyIndex).then((policyInfo) => {
                    this.showPaymentButton = false;
                    const callToAction = getCallToActionMapping(policyInfo);
                    if (callToAction) {
                        this.title = callToAction.header || '';
                        this.description = typeof(callToAction.copy) === 'string' ? callToAction.copy : callToAction.copy(policyInfo);
                        if (callToAction.ctaSref) {
                            this.showPaymentButton = true;
                            this.paymentsSref = callToAction.ctaSref(policyIndex);
                        }
                    } else {
                        $element.addClass('ng-hide');
                    }
                });
            } else {
                $element.addClass('ng-hide');
            }
        };
    }
});

export { module };
